"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLink = exports.isLinkProps = exports.Link = exports.LinkAnchor = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Router_1 = require("../../router/Router");
exports.LinkAnchor = react_1.forwardRef(function LinkAnchor(props, ref) {
    return jsx_runtime_1.jsx("a", Object.assign({}, props, { ref: ref }), void 0);
});
exports.Link = react_1.forwardRef(function Link(_a, ref) {
    var { Component = exports.LinkAnchor } = _a, props = tslib_1.__rest(_a, ["Component"]);
    if (props.href) {
        const { RouterLink } = Router_1.useRouterContext();
        return jsx_runtime_1.jsx(RouterLink, Object.assign({}, props, { Component: Component, ref: ref }), void 0);
    }
    return jsx_runtime_1.jsx(Component, Object.assign({}, props, { ref: ref }), void 0);
});
function isLinkProps(props) {
    return props.href !== undefined;
}
exports.isLinkProps = isLinkProps;
function useLink(props) {
    return jsx_runtime_1.jsx(exports.Link, Object.assign({}, props), void 0);
}
exports.useLink = useLink;
//# sourceMappingURL=Link.js.map